import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import store from "@/store/index";
// Initialize Firebase, copy this from the cloud console
// Or use mine :)
// Initialize Firebase
var config = {
  apiKey: "AIzaSyDperBGO-w4ZfLItxVXRkBOo_fXt7UZ6HI",
  authDomain: "soundslides-services.firebaseapp.com",
  databaseURL: "https://soundslides-services.firebaseio.com",
  projectId: "soundslides-services",
  storageBucket: "soundslides-services.appspot.com",
  messagingSenderId: "692228897432"
};
const firebaseApp = firebase.initializeApp(config);

//firebase.initializeApp(config);

// When a user logs in or out, save that in the store
firebase.auth().onAuthStateChanged(user => {
  console.log("Logged in as:", user);
  // Pass to VueX?
  store.commit("set_user", user);
  if (store.state.initial_signup) {
    // This is the very first time the user has been auth changed.
    store.dispatch("sendEmailVerification");
    setTimeout(function() {
      store.dispatch("redirectToShows");
    }, 500);
  }
  // Check to see if user is part of a group license!
  // Checks on every login/page refresh.
  // It's a light-weight check on lambda.
  if (user) {
    store.dispatch("triggerLicenseSync");
  }
});

export const db = firebaseApp.firestore();

// // Disable deprecated features
// db.settings({
//   timestampsInSnapshots: true
// });
//
